import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  CasesService,
  myAcquiredCaseInformation,
} from '../../../service/cases.service';

@Component({
  selector: 'app-my-cases-modal',
  template: `
    <app-loading *ngIf="loading"></app-loading>
    <ng-container *ngIf="!loading">
      <div class="col-12 d-flex justify-content-center">
        <h3>Detalhes do Caso</h3>
      </div>
      <div class="col-12 d-flex flex-column">
        <div class="d-flex flex-column">
          <div>
            <strong>Nome do Cliente: </strong>
            <span>{{ caseInfo.casePatientId.name }}</span>
          </div>
          <div>
            <strong>Documento: </strong>
            <span>
              {{
                !caseInfo.casePatientId.document
                  ? 'Não informado.'
                  : (caseInfo.casePatientId.document | mask : '999.999.999-99')
              }}
            </span>
          </div>
        </div>
        <div class="d-flex flex-column">
          <br />
          <h4>Contatos:</h4>
          <div
            *ngFor="let contact of caseInfo.casePatientId.contacts"
            style="padding: 2px 0; display: flex; gap: 10px;"
          >
            <span
              *ngIf="
                contact.contactMethod === 'Celular' ||
                contact.contactMethod === 'WhatsApp'
              "
            >
              <fa-icon icon="phone"></fa-icon>
            </span>
            <span *ngIf="contact.contactMethod === 'Email'">
              <fa-icon icon="envelope"></fa-icon>
            </span>
            <a
              *ngIf="
                contact.contactMethod === 'Celular' ||
                contact.contactMethod === 'WhatsApp'
              "
              style="cursor: pointer; color: black"
              target="_blank"
              [href]="'https://wa.me/55' + contact.contact"
              title="Enviar mensagem"
            >
              {{ contact.contact | mask : '(99) 99999-9999' }}
            </a>
            <span *ngIf="contact.contactMethod === 'Email'">{{
              contact.contact
            }}</span>
          </div>
        </div>
        <div class="d-flex flex-column">
          <br />
          <h4>Detalhes:</h4>
          <div class="d-flex flex-column" style="gap: 5px">
            <div>
              <strong>Tipo de Benefício Desejado: </strong>
              <span>
                {{
                  caseInfo.benefitType === 'Outro'
                    ? caseInfo?.benefitDescription
                    : caseInfo.benefitType
                }}
              </span>
            </div>
            <div>
              <strong>Situação Atual no INSS: </strong>
              <span>{{ caseInfo.inssStatus }}</span>
            </div>
            <div class="d-flex flex-column">
              <div>
                <strong>Documentação Médica: </strong>
                <span>{{
                  caseInfo.hasMedicalDocument
                    ? 'Cliente possui documento médico'
                    : 'Cliente não possui documento médico'
                }}</span>
              </div>
              <div *ngIf="caseInfo.hasMedicalDocument">
                <span>
                  {{
                    caseInfo.documentHasCid === null
                      ? 'Cliente não informou se documento possui hipótese diagnóstica ou CID'
                      : caseInfo.documentHasCid
                      ? 'Documentos possuem hipótese diagnóstica ou CID'
                      : 'Documentos não possuem hipótese diagnóstica ou CID'
                  }}
                </span>
              </div>
            </div>
            <div>
              <strong>Situação de Elegibilidade (BPC): </strong>
              <span>{{ situacaoSocial + cadUnico }}</span>
            </div>
            <div>
              <strong>Período de Carência: </strong>
              <span>{{
                caseInfo.periodRequirement === null
                  ? 'Não sabe informar'
                  : caseInfo.periodRequirement
                  ? 'Sim'
                  : 'Não'
              }}</span>
            </div>
            <br />
            <div>
              <strong>Observações: </strong>
              <span> {{ caseInfo.observation }}</span>
            </div>
          </div>
        </div>
        <br />
        <div class="col-12 d-flex justify-content-end">
          <button mat-button class="btn-danger" (click)="closeModal()">
            Fechar
          </button>
        </div>
      </div>
    </ng-container>
  `,
  styles: [
    `
      h3 {
        margin: 0 0 20px 0;
      }
      h4 {
        margin: 0;
        font-size: 18px;
      }
    `,
  ],
})
export class MyCasesModalComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<MyCasesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly service: CasesService
  ) {}

  situacaoSocial: string = '';
  cadUnico: string = '';
  loading: boolean = true;
  caseInfo: myAcquiredCaseInformation;

  ngOnInit(): void {
    this.getCaseInfo();
  }

  closeModal() {
    this.dialogRef.close();
  }

  private getCaseInfo() {
    this.service.getCaseInformationById(this.data.caseId).subscribe({
      next: (response) => {
        this.caseInfo = response;

        this.situacaoSocial = this.caseInfo.isBpc
          ? 'Cliente está em situação de vulnerabilidade'
          : this.data.isBpc === null
          ? 'Não se aplica'
          : 'Não está em situação de vunerabilidade';

        this.cadUnico = this.caseInfo.isBpc
          ? this.caseInfo.isCadUnico
            ? '/ Cliente está inscrito no CadÚnico'
            : this.caseInfo.isCadUnico === null
            ? '/ Cliente não sabe informar se participa do CadÚnico'
            : '/ Cliente não está cadastrado no CadÚnico'
          : '';

        this.loading = false;
      },
      error: (err) => {
        console.log('Usuario não tem permissão para acessar.', err);
      },
    });
  }
}
